<template>
  <slot name="search"></slot>
  <!-- eslint-disable vue/no-v-model-argument -->
  <a-tabs v-model:activeKey="activeKey">
    <a-tab-pane key="1" tab="设备备份">
      <slot name="device"></slot>
    </a-tab-pane>
    <a-tab-pane key="2" tab="空间备份">
      <slot name="space"></slot>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
import { defineComponent, ref } from "vue";
import { Tabs } from "ant-design-vue";
const ATabPane = Tabs.TabPane;
export default defineComponent({
  components: {
    ATabs: Tabs,
    ATabPane: ATabPane
  },
  setup() {
    const activeKey = ref("1");
    return {
      activeKey
    };
  }
});
</script>

<style lang="less" scoped>
:deep(.ant-tabs-tab) {
  margin-left: 4px;
  padding: 12px 16px;
  &:hover {
    color: #5e66f2;
  }
}
:deep(.ant-tabs-ink-bar-animated) {
  display: none;
}
:deep(.ant-tabs-tab-active) {
  border-bottom: 2px solid #5e66f2;

  .ant-tabs-tab-btn {
    color: #5e66f2;
  }
}
</style>
